import * as React from 'react';
import { connect } from 'react-redux';
import BibleChapter from 'src/bible/BibleChapter';
import SourceTextCache from 'src/new/sources/SourceTextCache';
import Version from 'src/new/versions/Version';
import VersionStore from 'src/new/versions/VersionStore';
import AppState from 'src/redux/AppState';
import SearchQuery from 'src/search2/SearchQuery';
import BaseListItem, { BaseListItemProps } from './BaseListItem';
import './ChapterListItem.css';

interface OwnProps extends BaseListItemProps {
    chapter: BibleChapter;
    versions: VersionStore;
    selectedVersionIndex: number;
    sourceTextCache: SourceTextCache;
    highlightQuery: SearchQuery;
}

interface StateProps {
    showInterlinearNumbers: boolean;
}

const mapStateToProps = (state: AppState): StateProps => ({
    showInterlinearNumbers: state.settings.showInterlinearNumbers
});

type Props = OwnProps & StateProps;

class ChapterListItem extends BaseListItem<Props> {

    protected renderContent(): React.ReactNode {
        const version = this.props.versions.getVersion(this.props.selectedVersionIndex);
        return (
            <div className="ChapterListItem">
                <div className="ChapterListItem_LeftMargin" />
                <div className="ChapterListItem_Content">
                    <div className="ChapterListItem_Header _Default">
                        <div className="ChapterListItem_VersionCode">{version.getCode()}</div>
                        <div className="ChapterListItem_ChapterName">{this.props.chapter.getName()}</div>
                    </div>
                    {this.renderVerseText(version)}
                </div>
            </div>
        );
    }

    private renderVerseText(version: Version): React.ReactNode {
        interface VerseText {
            number: string;
            text: string;
        }

        const verseText = this.props.chapter.getVerses()
            .map<VerseText>((verse) => {
                return {
                    number: String(verse.getNumber()),
                    text: version.getRenderer().render(verse.getIndex(), this.props.sourceTextCache, {
                        highlightQuery: this.props.highlightQuery,
                        noInterlinearNumbers: !this.props.showInterlinearNumbers
                    })
                };
            })
            .filter(text => text.text !== '');

        if (verseText.length === 0) {
            verseText.push({
                number: '',
                text: '<div class="ChapterListItem_Empty _Default">No text for this chapter</div>'
            });
        }

        return verseText.map((text) => (
            <div key={text.number} className="ChapterListItem_Verse">
                <div className="ChapterListItem_VerseNumber _Default">{text.number}</div>
                <div dangerouslySetInnerHTML={{ __html: text.text }} />
            </div>
        ));
    }
}

export default connect(mapStateToProps)(ChapterListItem);
